export default {
  downtimeUrl: "https://pl3.kodland.tech",
  startPage: {
    image: "/welcome/quiz_pl_fwd_d.png",
    imageMobile: "/welcome/quiz_pl_fwd_m.png",
    title: "Nauczymy dziecko tworzyć własne komiksy i projekty graficzne!",
    subtitle:
      "Wypełnij naszą 1-minutową ankietę, a otrzymasz zaproszenie na DARMOWĄ lekcję kodowania lub animacji online 🔥",
    button: "Zaczynajmy 😎",
    gift: 10
  },
  successPage: {
    title: "Wybierz datę i godzinę, aby otrzymać lekcję ZA DARMO",
    subtitle: "Kliknij przycisk “📆 Zarezerwować lekcję“, aby dokończyć rejestrację",
    button: "📆 Zarezerwować lekcję",
  },
  stopPage: {
    image: "/welcome/quiz_stop_page.jpg",
    title: "Dziękujemy za zaufanie do naszej platformy edukacyjnej! Niestety, tablety czy telefony nie nadają się na lekcje. Czekamy na Państwo na zajęciach następnym razem!",
  },
  quizRotateBySteps: {
    1: {
      question: "Czym zajmuje się Twoje dziecko?",
      answers: [
        "🎨 Lubi rysować", 
        "🙌 Wytwarza ręcznie robione przedmioty",  
        "🎮 Gra w gry wideo", 
        "✏️ Rysuje w programie 'Paint' ", 
        "🤔 Nigdy o tym nie rozmawialiśmy", 
      ],
    },
    2: {
      question: "Czy chcesz, aby Twoje dziecko opanowało profesjonalny program do tworzenia grafiki w ciągu kilku lekcji?",
      answers: [
        "😍 Tak! Wszystko to może się przydać w przyszłości",
        "🤗 Nie",
      ],
    },
    3: {
      question: "Jakie masz oczekiwania wobec nauki?",
      answers: [
        "💭 Rozwijanie twórczego myślenia", 
        "✍️ Zdobycie wiedzy z zakresu grafiki komputerowej",
        "👥 Rozwijanie umiejętności pracy w zespole",   
        "🥇 Uruchomienie własnych projektów twórczych",  
        "😎 Wypracowanie chęci i odwagi, aby marzyć",
        "💪 Rozwijanie samodzielności",
      ],
    },
    4: {
      question: "Czy masz komputer/laptop służący do nauki?",
      answers: [
        "👍 Tak",
        {
          answer: "😕 Nie",
          stopAnswer: true
        },
      ],
    },
  },
};
